import React, { useEffect, useState } from "react";
import feature from "./WhyFlit.json";
import Star from "../star/Star";

const Why = () => {
  const [features, setFeatures] = useState(feature);
  // const [currentIndex, setCurrentIndex] = useState(0);
  // const [isAnimating, setIsAnimating] = useState(false);
  // const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  // useEffect(() => {
  //   const handleResize = () => setIsDesktop(window.innerWidth >= 768);
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  // useEffect(() => {
  //   if (!isDesktop) return;

  //   const interval = setInterval(() => {
  //     setIsAnimating(true); // Start animation
  //     setTimeout(() => {
  //       setFeatures((prev) => {
  //         const first = prev[0];
  //         const rest = prev.slice(1);
  //         return [...rest, first]; // Move first to end
  //       });
  //       setIsAnimating(false); // Reset animation
  //     }, 1000); // Match transition duration
  //   }, 3000); // Auto-scroll every 3 seconds

  //   return () => clearInterval(interval);
  // }, [isDesktop]);

  return (
    <div
      className="flex flex-col gap-[92px] justify-center items-center max-w-[100vw] overflow-x-clip"
      id="why"
    >
      <div className="flex flex-col gap-4 leading-[150%] justify-center items-center">
        <h2 className="font-semibold text-4xl ">Why Choose Flit?</h2>
      </div>
      <div className="flex lg:hidden gap-14 lg:flex-row  flex-col  justify-center items-center relative">
        {feature.map((data) => (
          <div
            key={data.id}
            className=" w-[361px] h-[298px] flex  justify-center relative z-30    "
          >
            <div className="absolute  w-[600px]  h-[316px] z-20 -top-[22px] -left-6 rounded-full">
              <img src="/Images/assets/SmallRectangle.svg" alt="" />
            </div>

            <div className="w-[348px] h-[100px] absolute bg-white z-40 left-3 top-[185px] rounded-3xl"></div>

            <div className="relative z-50 w-[332px]  flex flex-col gap-5 bg-transparent justify-center items-center text-center p-5">
              <div className="w-24 h-24 flex justify-center items-center rounded-3xl bg-[#D3F5E9] -mt-12">
                <img src={`/Images/assets/${data.image}.svg`} alt="" />
              </div>
              <h3 className="text-[26px] font-semibold text-[#01120A]">
                {data.title}
              </h3>
              <p className="font-medium lg:text-base text-sm leading-[180%] text-[#181818] opacity-60">
                {data.desc}
              </p>
            </div>
          </div>
        ))}
        <div className="absolute w-screen lg:bottom-0 -bottom-2 z-0">
          <div class="w-0 h-0  border-l-[60vw]     border-l-transparent absolute bottom-0 right-0 lg:border-b-[200px] border-b-[118px] border-b-[#E5204B]"></div>
          <div class="w-0 h-0 border-r-[60vw]     border-r-transparent  absolute bottom-0 left-0 lg:border-b-[200px] border-b-[118px] border-b-[#E5204B]"></div>
        </div>
      </div>

      <div className="hidden lg:flex w-[1200px] relative h-[400px] items-end justify-center gap-0">
        <div className="absolute lg:block hidden right-96 top-8  z-50">
          <Star />
        </div>
        <div className={`flex justify-center items-end  `}>
          {features.map((data, index) => (
            <div
              key={data.id}
              className={`flex-shrink-0 w-[361px] -mb-[2px] h-[267px] flex justify-center relative z-30  lg:rounded-none rounded-3xl bg-transparent transition-all duration-500 ${
                index === 1
                  ? " z-40  w-[484px] h-[374px] manual-shadow bg-white"
                  : " w-[348px] h-[267px] "
              }`}
            >
              {index !== 1 && (
                <div
                  className={`absolute  w-[600px] max-h-[374px] h-[316px] z-20 -top-[22px]  ${
                    index === 0 ? "-left-[22px]" : "-left-9"
                  }`}
                >
                  <img src="/Images/assets/SmallRectangle.svg" alt="" />
                </div>
              )}

              <div
                className={`relative z-30 ${
                  index === 1 ? "w-[388px]" : "w-[332px]"
                } ${
                  index === 0 ? " ml-3" : ""
                } flex flex-col gap-5 bg-transparent justify-center items-center text-center p-5 `}
              >
                <div
                  className={` flex justify-center items-center  bg-[#D3F5E9] -mt-12 ${
                    index === 1
                      ? "rounded-full w-[147px] h-[147px] -mt-14"
                      : "rounded-3xl w-24 h-24 -mt-12"
                  }`}
                >
                  <img src={`/Images/assets/${data.image}.svg`} alt="" />
                </div>
                <h3
                  className={` ${
                    index === 1 ? "text-[38px]" : "text-[26px]"
                  } font-semibold text-[#01120A]`}
                >
                  {data.title}
                </h3>
                <p
                  className={`font-medium lg:text-base text-sm leading-[180%] text-[#181818] opacity-60 
                    ${index === 1 ? "w-[388px]" : "w-[262px]"}
                  `}
                >
                  {index === 1
                    ? "Unlike others, Flit takes no cuts—riders keep 100% of earnings, and merchants pay zero commission. More savings, fair pricing, and better profits for all."
                    : data.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="absolute w-screen lg:bottom-0 -bottom-6 z-20">
          <div class="w-0 h-0  border-l-[60vw]     border-l-transparent absolute bottom-0 right-0 lg:border-b-[200px] border-b-[118px] border-b-[#E5204B]"></div>
          <div class="w-0 h-0 border-r-[60vw]     border-r-transparent  absolute bottom-0 left-0 lg:border-b-[200px] border-b-[118px] border-b-[#E5204B]"></div>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default Why;

{
  /* <div className="w-[534px] h-[424px] flex  justify-center relative z-40 -ml-[82px] -mb-8">
  <div className="absolute w-[534px] h-[424px] z-10 top-0 left-0">
    <img src="/Images/assets/BigRectangle.svg" alt="" />
  </div>

  <div className="relative z-20 w-[484px]  flex flex-col gap-5 bg-transparent justify-center items-center text-center p-5">
    <div className="w-24 h-24 flex justify-center items-center rounded-3xl bg-[#D3F5E9] -mt-12">
      <img src="/Images/assets/bomb.svg" alt="" />
    </div>
    <h3 className="text-[26px] font-semibold text-[#01120A]">
      Zero Commissions
    </h3>
    <p className="font-medium text-base leading-[180%] text-[#181818] opacity-60">
      Unlike others, Flit takes no cuts—riders keep 100% of earnings,
      and merchants pay zero commission. More savings, fair pricing, and
      better profits for all.
    </p>
  </div>
</div>
<div className="w-[398px] h-[307px] flex  justify-center relative z-30 -ml-[82px]">
  <div className="absolute w-[398px] h-[307px] z-10 top-0 left-0">
    <img src="/Images/assets/SmallRectangle.png" alt="" />
  </div>

  <div className="relative z-20 w-[346px]  flex flex-col gap-5 bg-transparent justify-center items-center text-center p-5">
    <div className="w-24 h-24 flex justify-center items-center rounded-3xl bg-[#D3F5E9] -mt-12">
      <img src="/Images/assets/location.svg" alt="" />
    </div>
    <h3 className="text-[26px] font-semibold text-[#01120A]">
      Deliver Anything
    </h3>
    <p className="font-medium text-base leading-[180%] text-[#181818] opacity-60">
      Food, groceries, documents, <br /> medicines—send it all with
      ease.
    </p>
  </div>
</div> */
}
